import { createContext, useState, useEffect } from 'react'
import { CompanyAPI } from 'apis/CompanyAPI'
import useAuthStore from './authStore'

export const CompaniesContext = createContext()

export const CompaniesProvider = ({ children }) => {
    const [companies, setCompanies] = useState([])
    const accessToken = useAuthStore(state => state.accessToken)

    useEffect(() => {
        if (!accessToken) {
            setCompanies([])
            return
        }
        let active = true
        CompanyAPI.getAll().then(resp => {
            if (active) setCompanies(resp.result)
        }).catch(error => console.error('Failed to fetch companies:', error))
        return () => { active = false }
    }, [accessToken])

    return (
        <CompaniesContext.Provider value={{ companies, setCompanies }}>
            {children}
        </CompaniesContext.Provider>
    )
}
